export const transformJobDataToGroupedObject = (jobs, isEnterprise = false,is_checked=true) => {

  const Capitalize = (str) => {

    if (!str) return '';
    if (str == 'twitter') return 'X';
    if (str == 'youtube') return 'YouTube';
    if (str == 'flipkart') return 'flipkart';

    return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
  };

  const grouped = {};
  if (isEnterprise == true) {
    jobs.forEach(job => {
      // if (job.is_active !== 0) return;
      const channel = 'Enterprise';

      const title = job.title || '';

      if (!grouped[channel]) {
        grouped[channel] = [];
      }

      grouped[channel].push({
        title,
        isChecked: is_checked,
        job_id: job?.job_id,
      });
    });
  } else {
    jobs.forEach(job => {
      if (job.is_active !== 0) return;
      const channel = Capitalize(job?.channel || 'Unknown');

      const title = job.chatter_title || job.topic_title || job.title || '';

      if (!grouped[channel]) {
        grouped[channel] = [];
      }
      if (['Facebook', 'YouTube', 'flipkart'].includes(channel)) {
        return; // <-- safer than continue
      }
      grouped[channel].push({
        title,
        isChecked: is_checked,
        job_id: job?.job_id,
        search_type:job?.search_type
      });
    });
  }


  return grouped;
};


export const yearFilter = (arr1, arr2) => {
  const extractYear = (d) => {
    if (!d) return null;
    const parts = d.split('/');
    return parts[1]; // Extract year from "MM/YYYY"
  };

  const allYearsSet = new Set(
    [...(arr1?.timeline || []), ...(arr2?.timeline || [])]
      .map(extractYear)
      .filter(Boolean)
  );

  const uniqueSortedYears = Array.from(allYearsSet).sort((a, b) => a - b);

  return uniqueSortedYears.map((year) => ({
    label: year,
    value: Number(year),
  }));
};

export const convertSourceAnalysis = (sourceAnalysis) => {
  const fullData = [];
  const subDataMap = {};

  Object.entries(sourceAnalysis).forEach(([key, value]) => {
    fullData.push({
      label: key,
      value: value.total,
    });

    const segments = value.segments || {};
    subDataMap[key] = Object.entries(segments).map(([subKey, subVal]) => ({
      label: subKey,
      value: subVal,
    }));
  });

  return { fullData, subDataMap };
};

export const TrendsArray = (type = 'topic', timeSpan = 'Days', getConsoleData = {}) => {
  const trends_in_user_activity = {
    topic: {
      days: {
        timeline:
          getConsoleData?.user_activity_trends?.days?.topic?.timeline ||
          getConsoleData?.user_activity_trends?.days?.twitter?.timeline ||
          getConsoleData?.user_activity_trends?.days?.instagram?.timeline ||
          getConsoleData?.user_activity_trends?.days?.facebook?.timeline ||
          getConsoleData?.user_activity_trends?.days?.youtube?.timeline ||
          [],
        count:
          getConsoleData?.user_activity_trends?.days?.topic?.count ||
          getConsoleData?.user_activity_trends?.days?.twitter?.count ||
          getConsoleData?.user_activity_trends?.days?.instagram?.count ||
          getConsoleData?.user_activity_trends?.days?.facebook?.count ||
          getConsoleData?.user_activity_trends?.days?.youtube?.count ||
          [],
      },
      week: {
        timeline:
          getConsoleData?.user_activity_trends?.week?.topic?.timeline ||
          getConsoleData?.user_activity_trends?.week?.twitter?.timeline ||
          getConsoleData?.user_activity_trends?.week?.instagram?.timeline ||
          getConsoleData?.user_activity_trends?.week?.facebook?.timeline ||
          getConsoleData?.user_activity_trends?.week?.youtube?.timeline ||
          [],
        count:
          getConsoleData?.user_activity_trends?.week?.topic?.count ||
          getConsoleData?.user_activity_trends?.week?.twitter?.count ||
          getConsoleData?.user_activity_trends?.week?.instagram?.count ||
          getConsoleData?.user_activity_trends?.week?.facebook?.count ||
          getConsoleData?.user_activity_trends?.week?.youtube?.count ||
          [],
      },
      month: {
        timeline:
          getConsoleData?.user_activity_trends?.month?.topic?.timeline ||
          getConsoleData?.user_activity_trends?.month?.twitter?.timeline ||
          getConsoleData?.user_activity_trends?.month?.instagram?.timeline ||
          getConsoleData?.user_activity_trends?.month?.facebook?.timeline ||
          getConsoleData?.user_activity_trends?.month?.youtube?.timeline ||
          [],
        count:
          getConsoleData?.user_activity_trends?.month?.topic?.count ||
          getConsoleData?.user_activity_trends?.month?.twitter?.count ||
          getConsoleData?.user_activity_trends?.month?.instagram?.count ||
          getConsoleData?.user_activity_trends?.month?.facebook?.count ||
          getConsoleData?.user_activity_trends?.month?.youtube?.count ||
          [],
      },
      year: {
        timeline:
          getConsoleData?.user_activity_trends?.year?.topic?.timeline ||
          getConsoleData?.user_activity_trends?.year?.twitter?.timeline ||
          getConsoleData?.user_activity_trends?.year?.instagram?.timeline ||
          getConsoleData?.user_activity_trends?.year?.facebook?.timeline ||
          getConsoleData?.user_activity_trends?.year?.youtube?.timeline ||
          [],
        count:
          getConsoleData?.user_activity_trends?.year?.topic?.count ||
          getConsoleData?.user_activity_trends?.year?.twitter?.count ||
          getConsoleData?.user_activity_trends?.year?.instagram?.count ||
          getConsoleData?.user_activity_trends?.year?.facebook?.count ||
          getConsoleData?.user_activity_trends?.year?.youtube?.count ||
          [],
      },
    },
    chatter: {
      days: {
        timeline:
          getConsoleData?.user_activity_trends?.days?.chatter?.timeline ||
          getConsoleData?.user_activity_trends?.days?.flipkart?.timeline ||
          [],
        count:
          getConsoleData?.user_activity_trends?.days?.chatter?.count ||
          getConsoleData?.user_activity_trends?.days?.flipkart?.count ||
          [],
      },
      week: {
        timeline:
          getConsoleData?.user_activity_trends?.week?.chatter?.timeline ||
          getConsoleData?.user_activity_trends?.week?.flipkart?.timeline ||
          [],
        count:
          getConsoleData?.user_activity_trends?.week?.chatter?.count ||
          getConsoleData?.user_activity_trends?.week?.flipkart?.count ||
          [],
      },
      month: {
        timeline:
          getConsoleData?.user_activity_trends?.month?.chatter?.timeline ||
          getConsoleData?.user_activity_trends?.month?.flipkart?.timeline ||
          [],
        count:
          getConsoleData?.user_activity_trends?.month?.chatter?.count ||
          getConsoleData?.user_activity_trends?.month?.flipkart?.count ||
          [],
      },
      year: {
        timeline:
          getConsoleData?.user_activity_trends?.year?.chatter?.timeline ||
          getConsoleData?.user_activity_trends?.year?.flipkart?.timeline ||
          [],
        count:
          getConsoleData?.user_activity_trends?.year?.chatter?.count ||
          getConsoleData?.user_activity_trends?.year?.flipkart?.count ||
          [],
      },
    },
  };
  let arr = []
  if (type == 'topic') {
    if (timeSpan == 'Days') {
      arr = trends_in_user_activity?.topic?.days || []
    } else if (timeSpan == 'Months') {
      arr = trends_in_user_activity?.topic?.month || []

    } else if (timeSpan == 'Weeks') {
      arr = trends_in_user_activity?.topic?.week || []

    } else if (timeSpan == 'Years') {
      arr = trends_in_user_activity?.topic?.year || []

    } else {
      arr = []
    }

  } else {
    if (timeSpan == 'Days') {
      arr = trends_in_user_activity?.chatter?.days || []
    } else if (timeSpan == 'Months') {
      arr = trends_in_user_activity?.chatter?.month || []

    } else if (timeSpan == 'Weeks') {
      arr = trends_in_user_activity?.chatter?.week || []

    } else if (timeSpan == 'Years') {
      arr = trends_in_user_activity?.chatter?.year || []

    } else {
      arr = []
    }
  }
  return arr;
}